import React from 'react';
import { List, ListItem, Heading, Icon } from 'components/chroma';
import { replaceSpaces } from 'scenes/common/helpers/text';
import styled from 'styled-components';
import THEME from 'theme';

const ClaimSupportWrapper = styled.div`
  margin-bottom: 1rem;
  margin-top: 1rem;

  h4 {
    font-size: 1rem;
  }

  .c-icon {
    color: ${THEME.TICK_ICON.VALID};
  }
`;

type ClaimSupportProps = {
  items: JSX.Element[];
};

export const ClaimSupport = ({ items }: ClaimSupportProps) => (
  <ClaimSupportWrapper>
    <Heading size={4} margin={{ bottom: 2 }}>
      Our claims support
    </Heading>
    <List>
      {items.map((benefit) => (
        <ListItem key={replaceSpaces(benefit.props.listkey)}>
          <Icon name="checkCircle" margin={{ right: 2 }} /> {benefit}
        </ListItem>
      ))}
    </List>
  </ClaimSupportWrapper>
);
